import { call, fork, all } from 'redux-saga/effects';
import { getContent } from "./redux/store/sagas.js"

export function* initSagas() {
    yield all([
        call(getContent),
    ]);
}

export default function* mainSaga() {
    yield fork(initSagas);
}
